import {Avatar, Image, Popconfirm} from 'antd'
import {getType} from 'apis/model/base'
import classNames from 'classnames'
import getLinkToDetail from 'helpers/getLinkToDetail'
import preventParentEvent from 'helpers/preventParentEvent'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useCallback, useContext, useMemo} from 'react'
import {BiSolidChurch, BiSolidEdit, BiSolidLike, BiSolidMusic, BiTrash} from 'react-icons/bi'
import {GiBlackBook, GiBookmark, GiIronCross,} from 'react-icons/gi'
import {IoEllipsisHorizontal} from 'react-icons/io5'
import {RiChat3Line, RiQuestionAnswerFill, RiRepeat2Fill, RiSignalTowerFill} from 'react-icons/ri'
import ReactPlayer from 'react-player'
import {Link} from 'react-router-dom'
import {compose, fromRenderProps} from 'recompose'
import {getRowTitle} from 'views/AppLocals/Codi/codiHelpers'
import {Widget} from 'views/NewFeed/FeedWidget'
import {notEmpty, renderIf} from 'views/Shared'
import {PinnedIcon} from '../../assets/svgs/PinnedIcon'
import {Photo} from '../../conts/imageBase64'
import getTitle from '../../helpers/getTitle'
import {DocumentDetail} from '../../views/Document/components/DocumentDetail'
import {paths} from '../../views/MainPage/contains'
import {NullAsDefault} from '../../views/Shared'
import DrawMenu from '../drawer/DrawMenu'
import ImageLoader from '../ImageLoader'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {BaseEmbed, DetailEmbed, Keywords} from './BaseEmbed'
import Description from './Description'
import './FeedCard.css'
import FeedContext from './FeedContext'
import {GalleryEmbed} from './GalleryEmbed'
import {ExtraLike} from './Like'
import {PollEmbed} from './PollEmbed'
import {Share} from './Share'
import {VideoEmbed} from './VideoEmbed'
import {ExtraVote, Vote, VoteTypes} from './Vote'
import {BsBookmarkHeart, BsBookmarks, BsBookmarkX, BsFillPinAngleFill, BsPersonFill, BsPinAngle} from "react-icons/bs";
import {AnnouncementFeedCard, EmbedFeedCard, UserCheckinFeedCard, WoGFeedCard} from "./TimeLineFeed";
import {GodWordCardItem} from "../../views/AppLocals/WoG/components/GodWordCardItem";
import {IoMdBookmarks} from "react-icons/io";
import TooltipApp from "components/TooltipApp";
import {PiShareFat, PiWarningDuotone} from "react-icons/pi";
import {getId} from "../../apis/model/base";
import {post_getPostbyId_Api} from "../../apis";
import {createAsyncAction} from "../../modules/asyncCache";
import {useDispatch} from "react-redux";
import {useHistory} from "../../modules/navigation/useRouter";
import {ifThenElseMultipleConditions} from "../../helpers/ifThenElseMultipleConditions";
import {formatRelativeTime} from "../../helpers/dateUtils"
import {isPendingApproval} from "../../helpers/contentWarnings";
import {formatNumber} from "../../helpers/number";
import {FollowButton} from "./FollowButton";
import {UserCheckinCardItem} from "../../views/MainPage/MySpace/components/UserCheckinCardItem";
import {PrayerCard} from "./PrayerCard";
import {OrganizationAnnouncementItem} from "../../views/Organization/components/OrganizationAnnouncementItem";
import {CourseClassAnnouncementItem} from "../../views/AppLocals/Course/CourseClass/components/CourseClassAnnouncementItem";
import {GoDotFill} from "react-icons/go";

export const FeedFooter = () => {
    const {item, actions, handleClick} = useContext(FeedContext)
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)

    const {total_votes, total_comments, total_views, total_shares, poll_type} = item ?? {}
    const isQuiz = poll_type === 'quiz'
    const hasVoted = item?.vote_status === 1
    const othersVoteCount = Math.max(Number(total_votes) - (hasVoted ? 1 : 0), 0)

    return renderIf(
        _.some([total_votes, total_comments, total_views, total_shares]) > 0,
        <div className="flex flex-col FeedFooter">
            <div className="p-2 flex flex-col md:flex-row md:justify-between gap-2 border-b border-color-50">
                {total_votes > 0 && getType(item) !== 'ask' && (
                    <div className="flex items-center gap-1">
                        <Avatar.Group max={{count: 3}} className="items-center">
                            <Avatar
                                size={22}
                                icon={isQuiz
                                    ? <RiQuestionAnswerFill size={10} className="text-white"/>
                                    : <BiSolidLike size={10} className="text-white"/>}
                                style={{border: '2px solid #fff'}}
                                className={classNames('flex flex-center', isQuiz ? 'bg-purple-500' : 'bg-blue-600')}
                            />
                            {total_comments > 0 && (
                                <Avatar
                                    size={22}
                                    icon={<RiChat3Line size={10} className="text-white"/>}
                                    style={{border: '2px solid #fff'}}
                                    className="flex flex-center bg-green-500"
                                />
                            )}
                            {total_shares > 0 && (
                                <Avatar
                                    size={22}
                                    icon={<PiShareFat size={10} className="text-white"/>}
                                    style={{border: '2px solid #fff'}}
                                    className="flex flex-center bg-secondary-500"
                                />
                            )}
                        </Avatar.Group>
                        <span className="font-medium text-xs text-gray-700 tracking-wide leading-snug">
                            {isQuiz
                                ? <>{Number(item?.total_votes)} {t('quiz answers').toLowerCase()}</>
                                : hasVoted && othersVoteCount === 0
                                    ? <>{t('you')} {t('joined in prayer')}</>
                                    : <>{hasVoted && t('you and')} {othersVoteCount} {t('someone else').toLowerCase()} {t('joined in prayer')}</>}
                        </span>
                    </div>
                )}
                {renderIf(
                    _.some([total_comments || total_shares || total_views]) > 0,
                    <div className="mx-2 md:mx-0 flex items-center gap-x-3">
                        {total_comments > 0 && (
                            <div onClick={() => handleClick('to')} style={{lineHeight: 1.2}}
                                 className="flex items-baseline gap-1 tracking-wider text-xs">
                                <label className="font-medium text-color-000">
                                    {formatNumber(Number(total_comments))}
                                </label>
                                <span className="text-slate-400 hover:text-color-100 hover:underline cursor-pointer">
                                {t('comment').toLowerCase()}
                            </span>
                            </div>
                        )}
                        {total_shares > 0 && (
                            <div style={{lineHeight: 1.2}} className="flex items-baseline gap-1 tracking-wider text-xs">
                                <GoDotFill size={8} className="text-gray-500"/>
                                <label className="font-medium text-color-000">
                                    {formatNumber(Number(total_shares))}
                                </label>
                                <label className="text-slate-400">
                                    {t('share').toLowerCase()}
                                </label>
                            </div>
                        )}
                        {total_views > 0 ? (
                            <div onClick={() => handleClick('to')} style={{lineHeight: 1.2}}
                                 className="flex items-baseline gap-1 tracking-wider text-xs">
                                <GoDotFill size={8} className="text-gray-500"/>
                                <label className="font-medium text-color-000">
                                    {formatNumber(Number(total_views))}
                                </label>
                                <span className="text-slate-400 hover:text-color-100 hover:underline cursor-pointer">
                                {t('views').toLowerCase()}
                            </span>
                            </div>
                        ) : (
                            actions.to && (
                                <div
                                    onClick={() => handleClick('to')}
                                    className="flex-1 truncate italic text-color-500 hover:text-color-100 font-normal text-xs cursor-pointer">
                                    {isLg ? t('show this post') : t('view')}
                                </div>
                            )
                        )}
                    </div>
                )}
            </div>
            <div className="FeedCardFooter flex items-center gap-3">
                <FeedActions className="justify-around gap-0 md:gap-3 px-1 md:px-2"/>
            </div>
        </div>
    )
}

const CodiRowMeta = () => {
    const {item} = useContext(FeedContext)
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {codi_document, index_typecd, index_name} = item ?? {}

    const {document_type, document_no} = codi_document ?? {}

    const renderDocumentType = (type) => {
        const {title, parent} = type ?? {}
        if (parent) {
            return [renderDocumentType(parent), title].join(' - ')
        }
        return title
    }

    const BookItem = () => (
        <div className="flex flex-col gap-1 relative">
            <span
                style={{padding: '3px 10px', borderRadius: '13px 15px 15px 0'}}
                className="w-fit flex flex-center gap-2 text-xs font-medium bg-primary-50 rounded-lg text-primary italic">
                <GiBookmark size={12}/> <span>{t('book')}</span>
            </span>
            <Link
                to={getLinkToDetail(codi_document)}
                target="_blank"
                className="font-bold text-color-000 no-underline mr-6 md:mr-0">
                {getTitle(codi_document)}
                {renderIf(
                    document_no,
                    <span className="font-medium text-sm text-color-400 italic ml-2 no-underline">
                        {`(${document_no})`}
                    </span>
                )}
            </Link>
            <GiBlackBook
                size={30}
                style={{
                    top: '50%',
                    right: isSm ? '10%' : '5%',
                    transform: 'translate(0, -50%)',
                }}
                className="absolute text-color-500 opacity-15"
            />
        </div>
    )

    const PagesItem = () => (
        <div className="flex flex-col gap-1 relative">
            <span
                style={{padding: '3px 10px', borderRadius: '13px 15px 15px 0'}}
                className="w-fit flex flex-center gap-1 text-xs font-medium background-200 rounded-lg text-color-200 italic">
                <IoMdBookmarks size={12}/> <span className="flex-1">{t('page')}</span>
            </span>
            <Link
                to={getLinkToDetail(item)}
                target="_blank"
                className="mt-2 font-bold text-sm text-color-100 italic no-underline mr-6 md:mr-0">
                {getRowTitle({item})}
                {' - '}
                <span className="font-bold text-color-000 no-underline">
                    {getTitle(codi_document)}
                    {renderIf(
                        document_no,
                        <span className="font-medium text-sm text-color-400 italic ml-2 no-underline">
                            {`(${document_no})`}
                        </span>
                    )}
                </span>
            </Link>
            <GiBlackBook
                size={30}
                style={{
                    top: '50%',
                    right: isSm ? '10%' : '5%',
                    transform: 'translate(0, -50%)',
                }}
                className="absolute text-color-500 opacity-15"
            />
        </div>
    )

    return (
        <div className="flex flex-col gap-1">
            {index_typecd === 'root' ? <BookItem/> : <PagesItem/>}
            {renderIf(
                document_type,
                <span
                    style={{padding: '2px 8px'}}
                    className="w-fit text-2xs font-medium bg-primary-50 rounded-full text-primary italic">
                    {renderDocumentType(document_type)}
                </span>
            )}
            <MetaActions/>
        </div>
    )
}

const PendingApprovalBadge = () => {
    const t = useTranslate()
    return (
        <span
            style={{padding: '2px 10px', background: '#fff7ed', color: '#c2410c'}}
            className="inline-flex items-center gap-1 rounded-full text-2xs font-semibold border border-orange-200 tracking-wide">
            <PiWarningDuotone size={11}/>
            {t('pending approval')}
        </span>
    )
}

export const FeedContentMeta = () => {
    const {item, handleClick} = useContext(FeedContext)
    const permissions = useContext(PermissionContext)
    const handleMenuClick = (e) => {
        handleClick(e.key)
    }
    const t = useTranslate()
    const isPending = isPendingApproval(item)

    const availbleActions = [
        // [icon,label,key]
        [RiSignalTowerFill, 'set_channel', 'set_channel', 'text-green-500'],
        item.bookmark_status ?
            [BsBookmarkX, 'unbookmark', {hasPermission: () => !isPending}, 'text-color-400'] :
            [BsBookmarkHeart, 'bookmark', {hasPermission: () => !isPending}, 'text-color-400'],
        [BsBookmarks, 'rebookmark', {hasPermission: () => !isPending}, 'text-color-400'],
        item.pin_status ? [BsFillPinAngleFill, 'unpin', 'unpin', 'text-green-500'] : [BsPinAngle, 'pin', 'pin', 'text-green-500'],
        item.edit ? [BiSolidEdit, 'edit', 'edit', 'text-blue-500'] : [],
        [BiTrash, 'delete', 'delete', 'text-primary-300'],
        [PiWarningDuotone, 'report', {hasPermission: (permissions) => true}, 'text-orange-500'],
    ].filter(
        ([
             Icon,
             key,
             {hasPermission = (permissions, key) => permissions[key]} = {},
         ]) => hasPermission(permissions, key)
    )

    const MusicContent = () => {
        const {isSm} = useContext(LayoutContext)
        const {music_types = [], music_authors = []} = item || {}

        return (
            <div className="flex flex-col gap-1 relative">
                {renderIf(
                    music_types.length > 0,
                    <div className="flex flex-wrap gap-2">
                        {music_types.map((e, i) => (
                            <span
                                key={i}
                                className="w-fit text-2xs font-medium bg-primary-50 text-primary italic leading-tight"
                                style={{
                                    padding: '4px 10px',
                                    borderRadius: i === 0 ? '13px 15px 15px 0' : '15px',
                                }}>
                                {e.title}
                            </span>
                        ))}
                    </div>
                )}
                <Link
                    to={getLinkToDetail(item)}
                    target="_blank"
                    className="font-bold text-color-000 no-underline mt-1 leading-tight">
                    {getTitle(item)}
                </Link>
                {renderIf(
                    music_authors.length > 0,
                    <div className="flex-1 items-baseline gap-1">
                        <span className="text-xs text-color-500 italic">
                            {`${t('author')} : `}
                        </span>
                        {music_authors.map((e, i) => (
                            <span
                                key={i}
                                className="font-bold text-xs text-color-100 italic">
                                {e.fullname} {i < music_authors.length - 1 && ' - '}
                            </span>
                        ))}
                    </div>
                )}
                <BiSolidMusic
                    size={40}
                    style={{
                        top: '50%',
                        right: isSm ? '10%' : '5%',
                        transform: 'translate(0, -50%)',
                    }}
                    className="absolute text-color-500 opacity-15"
                />
            </div>
        )
    }

    let Meta = DefaultMetaItem

    switch (getType(item)) {
        case 'codi_document_row':
            Meta = CodiRowMeta
            break
        case 'music':
            Meta = MusicContent
            break
        case 'user_checkin':
        case 'god_word':
            Meta = NullAsDefault
            break
        default:
            Meta = DefaultMetaItem
            break
    }

    return (
        renderIf(
            Meta !== NullAsDefault,
            <div className="w-full mt-1 px-2 py-1 relative">
                <Meta/>
                {isPending && (
                    <div className="mt-1">
                        <PendingApprovalBadge/>
                    </div>
                )}
                {availbleActions?.length > 0 && (
                    <DrawMenu
                        menu={{
                            items: availbleActions.map(([Icon, key, {label} = {}, color]) => ({
                                key: key || label,
                                icon: <Icon size={14} className={color}/>,
                                label: t(label || key || ''),
                            })),
                            onClick: handleMenuClick,
                        }}
                        component={
                            <Avatar
                                size={28}
                                icon={<IoEllipsisHorizontal size={18} className="text-color-200 hover:text-color-100"/>}
                                className="flex flex-center background hover:background-200 cursor-pointer absolute right-5 top-0 contextIcon"
                            />
                        }
                    />
                )}
            </div>
        )
    )
}

export const FeedActions = ({className, reportAccess = false}) => {
    const {isSm, isLg} = useContext(LayoutContext)
    const {actions, shareUrl, handleClick, item} = useContext(FeedContext)
    const t = useTranslate()
    const isPending = isPendingApproval(item)

    const ActionButton = ({icon, label, onClick}) => (
        <div
            onClick={onClick}
            style={{padding: isLg ? '4px 10px' : '4px'}}
            className="flex items-center gap-1 md:gap-2 hover:background-200 rounded-md cursor-pointer">
            {icon}
            {renderIf(
                label,
                <span className="text-xs md:text-sm text-color-300">
                    {t(label)}
                </span>
            )}
        </div>
    )

    return (
        <div className={classNames('flex items-center flex-1', className)}>
            {
                !['ask'].includes(getType(item)) && !isPending && (
                    <Vote id={item?.id}/>
                )
            }
            {actions?.voteUp && !isPending && (
                <ExtraVote
                    id={item?.id}
                    component={ExtraLike}
                    action={VoteTypes.UP}
                />
            )}
            {actions?.voteDown && !isPending && (
                <ExtraVote
                    id={item?.id}
                    component={ExtraLike}
                    action={VoteTypes.DOWN}
                />
            )}
            {actions?.message && (
                <ActionButton
                    key="message"
                    onClick={() => handleClick('to')}
                    icon={<RiChat3Line size={16} className="text-color-200"/>}
                    label="comment"
                />
            )}
            {renderIf(
                actions?.message
                && !isPending
                && ['article', 'post', 'ask', 'poll_question'].includes(getType(item))
                && (_.get(item, 'action', 'create') === 'create' || !!!_.get(item, 'action')),
                <ActionButton
                    key="quote"
                    onClick={() => handleClick('quote')}
                    icon={<RiRepeat2Fill size={16} className="text-color-200"/>}
                    label="repost"
                />
            )}
            {actions?.share && !isPending && (
                <Share
                    url={shareUrl}
                    id={item?.id}
                    component={
                        <ActionButton
                            icon={<PiShareFat size={16} className="text-color-200"/>}
                            label="share"
                        />
                    }
                />
            )}
        </div>
    )
}

const BlockRenderer = ({
                           description,
                           photos,
                           embed_data,
                           embed,
                           blocks: [
                               renderFirstBlock = NullAsDefault,
                               renderSecondBlock = NullAsDefault,
                               renderThirdBlock = NullAsDefault,
                               renderForthBlock = NullAsDefault,
                           ],
                           Wrapper = ({children}) => children,
                       }) => {
    return (
        <Wrapper>
            {description && renderFirstBlock()}
            {!_.isEmpty(photos) && renderSecondBlock()}
            {!_.isEmpty(embed_data) && renderThirdBlock()}
            {!_.isEmpty(embed) && renderForthBlock()}
        </Wrapper>
    )
}

const embedWithProps =
    ({item, keywords, categories}) =>
        (Wrapper) => {
            const {url, photo, title, host_url, description} = item

            return (
                <Wrapper
                    {...{
                        title,
                        url,
                        subTitle: host_url || url,
                        description,
                        image: photo,
                        categories,
                        keywords,
                    }}
                />
            )
        }

export const FeedEmbed = ({renderBlocks = BlockRenderer}) => {
    const t = useTranslate()
    const dispatch = useDispatch()
    const {
        item,
        article,
        cover,
        type,
        photos,
        handleClick,
        embed_data,
        embed,
        title,
        poll,
        shareUrl,
        description,
        mentions,
    } = useContext(FeedContext)

    const videoUrl = embed_data?.video_url || embed_data?.url;

    const canPlayVideo = React.useMemo(() => {
        if (!videoUrl) return false;
        return ReactPlayer.canPlay(videoUrl);
    }, [videoUrl]);

    const {post_type} = item ?? {}

    const itemAction = item?.action

    // Xem đầy đủ caption ("see more") mới thực sự tính là 1 view — caption ngắn hiển
    // sẵn trong feed không nên tự tính view. API get-by-id đã có sẵn cơ chế đếm
    // theo cache (CacheUpViews) để chống fake, chỉ cần gọi lại, không cần đổi gì thêm.
    const registerPostView = useCallback(() => {
        const postId = getId(item)
        if (!postId) return
        dispatch(createAsyncAction({
            apiInfo: post_getPostbyId_Api,
            query: {':post_id': postId},
        }))
    }, [dispatch, item])

    const renderFeedDescription = useCallback(() => {
        return (
            ifThenElseMultipleConditions(
                null,
                post_type === 'prayer',
                <div className="mx-3 content-prayer">{description}</div>,
                itemAction !== 're-post',
                <Description
                    type="post" mentions={mentions}
                    className="pb-3 text-base type-re-post 1111-1111"
                    truncatable maxLines={3}
                    onExpand={registerPostView}>
                    {description}
                </Description>
            )
        )
    }, [post_type, itemAction, description, mentions, registerPostView]);

    const renderFeedGallery = useCallback(() => {

        return (
            <div>
                <GalleryEmbed images={photos.map((item) => item.path)}/>
            </div>
        )
    }, [photos]);

    const renderFeedMedia = useCallback(() => {
        if (canPlayVideo) return (
            <div className="mx-3-ignored pb-3">
                <Link to={getLinkToDetail(item)}
                      className="font-bold text-base text-color-000 no-underline tracking-wide leading-snug">
                    {embed_data?.title}
                </Link>
                {renderIf(
                    description,
                    <div className="text-sm text-color-300 tracking-wider max-lines-2">
                        {description}
                    </div>
                )}
                <VideoEmbed
                    className="mt-1 FeedTimeLine"
                    host_name={_.get(embed_data, 'host_name')}
                    image={_.get(embed_data, 'host_name') === "facebook.com" && _.get(embed_data, 'photo')}
                    url={embed_data?.video_url || embed_data?.url}
                    subTitle={embed_data?.host_name}
                    description={embed_data?.description}
                    isShowPlayer={true}
                    title={embed_data?.title}
                />
            </div>
        )

        // ✅ FIX: Truyền props trực tiếp, KHÔNG dùng embedWithProps()(BaseEmbed)
        // embedWithProps tạo component type mới mỗi lần → React unmount/remount → gọi API lại
        const {url, photo, title, host_url, description: embedDesc, categories, keywords} = embed_data ?? {}
        return (
            <BaseEmbed
                title={title}
                url={url}
                subTitle={host_url || url}
                description={embedDesc}
                image={photo}
                categories={categories}
                keywords={keywords}
            />
        )
    }, [canPlayVideo, embed_data, description, item]);

    const renderFeedEmbed = useCallback(() => {
        if (_.get(item, 'action') !== 'quote') return null;
        switch (getType(_.get(item, 'embed'))) {
            case "god_word":
                return <WoGFeedCard item={embed}/>
            case "user_checkin":
                return <UserCheckinFeedCard item={embed}/>
            case "announcement":
                return embed?.owner_type === 'course_class'
                    ? <CourseClassAnnouncementItem item={embed}/>
                    : <AnnouncementFeedCard item={embed}/>
            default:
                return <EmbedFeedCard item={embed}/>
        }
    }, [item?.action, item?.embed, embed]);

    const PostWrapper = useMemo(() => {
        const {post_type, prayer_category_code, prayer_category, prayer_title} = item ?? {}
        if (post_type === 'prayer') {
            return ({children}) => (
                <PrayerCard {...{prayer_category_code, prayer_category, prayer_title}}>
                    {children}
                </PrayerCard>
            )
        }
        return ({children}) => <React.Fragment>{children}</React.Fragment>
    }, [item?.post_type, item?.prayer_category_code, item?.prayer_category, item?.prayer_title])

// ✅ Memoize blocks array để tránh tạo array mới mỗi render
    const postBlocks = useMemo(() => [
        renderFeedDescription,
        renderFeedGallery,
        renderFeedMedia,
        renderFeedEmbed,
    ], [renderFeedDescription, renderFeedGallery, renderFeedMedia, renderFeedEmbed])

    switch (type) {
        case 'music':
            return null
        case 'god_word':
            return (
                <div className="px-3 flex flex-col space-y-3 111222 GodWordCardItem">
                    <GodWordCardItem item={item}/>
                </div>
            )
        case 'user_checkin':
            return (
                <div className="px-3 flex flex-col space-y-3 1112223 UserCheckinCardItem">
                    <UserCheckinCardItem item={item}/>
                </div>
            )
        case 'ask':
            return (
                <div className="px-3 flex flex-col space-y-3 mb-2 AskCardItem">
                    <a
                        onClick={(e) => {
                            preventParentEvent(e)
                            handleClick('to')
                        }}
                        href={shareUrl}
                        className="font-bold text-color-000 no-underline leading-tight">
                        {title}
                    </a>
                    {description && (
                        <Description
                            type="ask"
                            mentions={mentions}>
                            {description}
                        </Description>
                    )}
                </div>
            )
        case 'post':
            const {photo, keywords, categories, post_type, prayer_category_code, prayer_category, prayer_title, ...rest} = item

            return renderBlocks({
                description,
                photos,
                embed_data,
                embed,
                Wrapper: PostWrapper,   // ✅ stable reference
                blocks: postBlocks,     // ✅ stable reference
            })
        case 'poll_question':
            return (
                <div className="flex flex-col">
                    {poll && <PollEmbed poll={poll}/>}
                </div>
            )
        case 'article':
            const article_categories = _.get(article, 'categories', [])
            const coverPhoto = _.get(article, 'cover_photo', cover)
            if (!article) {
                return null
            }
            return (
                <div className="p-3 flex flex-col gap-3 article-post">
                    <div className="flex flex-col gap-1">
                        {!_.isEmpty(title) && (
                            <a
                                onClick={(e) => {
                                    preventParentEvent(e)
                                    handleClick('to')
                                }}
                                href={shareUrl}
                                className="font-bold text-base text-color-000 no-underline tracking-wide leading-snug">
                                {title}
                            </a>
                        )}
                        {!_.isEmpty(description) && (
                            <div
                                onClick={(e) => {
                                    preventParentEvent(e)
                                    handleClick('to')
                                }}
                                className="flex-1 max-lines-3 text-sm text-color-300">
                                {description}
                            </div>
                        )}
                    </div>
                    {
                        coverPhoto && (
                            <ImageLoader
                                fallback={Photo}
                                src={coverPhoto}
                                className="w-full object-cover"
                                style={{objectPosition: "center"}}
                            />
                        )}
                    {!_.isEmpty(article_categories) && (
                        <div className="flex flex-wrap gap-3">
                            {article_categories.slice(0, 3).map((e, index) => (
                                <div
                                    key={index}
                                    className="flex items-center gap-1 text-primary-700">
                                    <GiIronCross size={8}/>
                                    <Link
                                        to={
                                            paths.categoryPath
                                                .replace(':category', e.id)
                                        }
                                        key={e.id}
                                        className="italic font-medium text-xs no-underline">
                                        {e.name}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )
        case 'announcement':
            return item?.owner_type === 'course_class' ? (
                <div className="CourseClassAnnouncement2">
                    <CourseClassAnnouncementItem item={item}/>
                </div>
            ) : (
                <div className="OrganizationAnnouncement">
                    <OrganizationAnnouncementItem item={item}/>
                </div>
            )
        default:
            return (
                <React.Fragment>
                    {description && (
                        <Description mentions={mentions} className="mx-3 text-base">{description}</Description>
                    )}
                </React.Fragment>
            )
    }
}

export const FeedContent = ({className = ""}) => (
    <div className={classNames("space-y-3 overflow-hidden FeedContent", className)}>
        <FeedEmbed/>
    </div>
)

export const DetailFeedContent = () => {
    const {
        item,
        type,
        photos = [],
        embed_data,
        embed,
        content_data,
        poll,
        description,
        mentions,
        others_in_container = []
    } = useContext(FeedContext)
    const {post_type, prayer_category_code, prayer_category, prayer_title} = item
    const videoUrl = embed_data?.video_url || embed_data?.url;

    const canPlayVideo = useMemo(() => {
        if (!videoUrl) return false;
        return ReactPlayer.canPlay(videoUrl);
    }, [videoUrl]);

    let contentArr = []
    if (!_.isEmpty(content_data)) {
        contentArr = content_data || []
    }
    const withEmbed = !_.isEmpty(Object.values(embed_data || {}).filter(notEmpty))
    const withRePost = !_.isEmpty(Object.values(embed || {}).filter(notEmpty))

    const renderFeedEmbed = useMemo(() => {
        const type = getType(embed);
        switch (type) {
            case "god_word":
                return <WoGFeedCard item={embed}/>
            case "user_checkin":
                return <UserCheckinFeedCard item={embed}/>
            case "announcement":
                return <AnnouncementFeedCard item={embed}/>
            case "prayer":
                return <EmbedFeedCard item={item}/>
            default:
                return (
                    <div className="shadow-md rounded-lg">
                        <EmbedFeedCard item={embed}/>
                    </div>
                )
        }

    }, [embed])

    return (
        <div className="space-y-3 overflow-hidden DetailFeedContent">
            {(type === 'post' || type === 're-post') && (
                <div className="space-y-6 post--re-post--content">
                    {description && (
                        ((post_type === 'prayer') && (type === 'post')) ? (
                            <PrayerCard {...{prayer_category_code, prayer_category, prayer_title}} className="">
                                {description}
                            </PrayerCard>
                        ) : (
                            <Description
                                type={type} mentions={mentions}
                                className="text-base tracking-wide">
                                {description}
                            </Description>
                        )
                    )}
                    {photos?.length > 0 && (
                        <GalleryEmbed images={photos?.map((item) => item.path)}/>
                    )}

                    {_.some([embed_data?.content_data?.length > 0, !_.isEmpty(content_data), others_in_container?.length > 0]) && (
                        <DetailEmbed
                            id={_.get(item, 'id')}
                            title={_.get(embed_data, 'title')}
                            url={_.get(embed_data, 'url')}
                            video_url={_.get(embed_data, 'video_url')}
                            subTitle={
                                _.get(embed_data, 'host_name') ||
                                _.get(embed_data, 'host_url') ||
                                _.get(embed_data, 'url')
                            }
                            description={_.get(embed_data, 'description')}
                            keywords={_.get(item, 'keywords')}
                            content={contentArr}
                            categories={_.get(item, 'categories')}
                            others={others_in_container}
                            photo={_.get(embed_data, 'photo')}
                        />
                    )}

                    {withEmbed && _.isEmpty(embed_data?.content_data)
                    && _.some([
                        _.get(embed_data, 'title'),
                        _.get(embed_data, 'description'),
                        !!canPlayVideo,
                        !!_.get(embed_data, 'photo')
                    ]) && (
                        <div
                            className="flex flex-col background-50 border border-color-50 rounded-lg DetailEmbedNotContentData">
                            {!!canPlayVideo && (
                                <VideoEmbed
                                    image={_.get(embed_data, 'host_name') === "facebook.com" && _.get(embed_data, 'photo')}
                                    url={embed_data?.url}
                                    subTitle={embed_data?.host_name}
                                    description={embed_data?.description}
                                    isShowPlayer={true}
                                    host_name={_.get(embed_data, 'host_name')}
                                />
                            )}
                            {!!_.get(embed_data, 'photo') && !!!canPlayVideo && (
                                <Image
                                    wrapperClassName="w-full rounded-t-lg embed-data-image"
                                    className="rounded-t-lg object-cover"
                                    preview={false}
                                    src={_.get(embed_data, 'photo')}
                                    fallback={Photo}
                                    style={{objectPosition: "center"}}
                                />
                            )}
                            {renderIf(
                                _.some([_.get(embed_data, 'title'), _.get(embed_data, 'description')]),
                                <div className="p-3 flex flex-col flex-1 gap-1 break-words">
                                    <div className="flex items-center gap-2">
                                        <p className="font-semibold text-secondary-600 tracking-wider">
                                            {_.get(embed_data, 'host_name')}
                                        </p>
                                        <span className="text-xs text-color-400">
                                            {`\u2022 ${formatRelativeTime(_.get(embed_data, 'published_at'))}`}
                                        </span>
                                    </div>
                                    <h1>
                                        <div
                                            className="font-bold text-gray-800 text-lg leading-snug">
                                            {_.get(embed_data, 'title')}
                                        </div>
                                    </h1>
                                    {renderIf(
                                        _.get(embed_data, 'description'),
                                        <div className="text-xs text-color-300 tracking-wider whitespace-pre-line">
                                            {_.get(embed_data, 'description')}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    {withRePost ? (
                        renderFeedEmbed
                    ) : null}
                </div>
            )}
            {/* TYPE: document */}
            {type === 'document' && (
                <DocumentDetail
                    item={item}
                    content={contentArr}
                    image={_.get(embed_data, 'photo')}
                />
            )}
            {/* TYPE: ask */}
            {type === 'ask' && (
                <div className="flex flex-col space-y-3">
                    <div className="text-lg">{_.get(item, 'title')}</div>
                    {description && (
                        <Description
                            type={type}
                            mentions={mentions}>
                            {description}
                        </Description>
                    )}
                    <FeedActions className="pt-2 mt-3 border-t"/>
                </div>
            )}
            {/* TYPE: poll question */}
            {type === 'poll_question' && poll && <PollEmbed poll={poll}/>}
            {_.get(item, 'widgets', []).length > 0 && (
                <div className="verticalList__small">
                    {_.get(item, 'widgets', []).map((e, i) => {
                        return (
                            <Widget
                                key={i}
                                index={i}
                                item={e}
                            />
                        )
                    })}
                </div>
            )}
            {/*  Keyword  */}
            {_.get(item, 'keywords', []).length > 0 && (
                <div style={{marginTop: '1rem', marginBottom: '1rem'}} className="mx-3 pt-4 border-t border-color-50">
                    <Keywords keywords={_.get(item, 'keywords', [])}/>
                </div>
            )}
        </div>
    )
}

export const FeedContentLayout = ({style, children}) => {
    return (
        <div
            style={style}
            className="FeedCardContent verticalList__small border border-color-50 hover:border-color-base">
            {children}
        </div>
    )
}

export const withFeedContext = compose(
    fromRenderProps(FeedContext.Consumer, (props) => props)
)

export const FeedWrapper = ({className, children}) => {
    const {item} = useContext(FeedContext)
    return (
        <div
            onContextMenu={item.content_disabled ? preventParentEvent : undefined}
            className={classNames(
                'FeedCard',
                item.content_disabled && 'content_disabled',
                className
            )}>
            {children}
        </div>
    )
}

const MetaActions = () => {
    const t = useTranslate()
    const {item, actions, handleClick} = useContext(FeedContext)
    return (
        !!item.pin_status &&
        (actions.pin && !!item.edit ? (
            <Popconfirm
                placement="bottomLeft"
                title={<span className="font-medium italic">{t('unpin this')}</span>}
                onConfirm={() => handleClick('unpin')}
                okText={t('yes')}
                cancelText={t('no')}
                okButtonProps={{
                    type: 'primary',
                    className: 'button-rounded-md no-border text-xs px-3',
                }}
                cancelButtonProps={{
                    className: 'button-rounded-md no-border text-xs text-color-400 px-3',
                }}>
                <TooltipApp title={t('unpin the post')}>
                    <PinnedIcon
                        size={16}
                        className="cursor-pointer custom-pin-icon ml-1 md:ml-3"
                    />
                </TooltipApp>
            </Popconfirm>
        ) : (
            <span/>
        ))
    )
}

const DefaultMetaItem = () => {
    const t = useTranslate()
    const history = useHistory()
    const {item, created, creatorName, embed_data, ...rest} = useContext(FeedContext)

    const {container, organization, course_class} = item ?? {}

    const isOrgAnnouncement = item?._type === 'announcement' && item?.owner_type !== 'course_class'
    const isCourseClassAnnouncement = item?._type === 'announcement' && item?.owner_type === 'course_class'

    return (
        <div className="flex items-center gap-2 lg:gap-3 mr-8">
            {ifThenElseMultipleConditions(
                // default
                <Avatar
                    size={40}
                    src={_.get(item, 'owner.avatar')}
                    icon={<BsPersonFill size={20} className="text-color-500"/>}
                    className="flex flex-center background-200 flex-shrink-0"
                />,
                item?.action === 're-post',
                <Avatar
                    size={40}
                    src={_.get(container, 'owner.avatar')}
                    icon={<BsPersonFill size={20} className="text-color-500"/>}
                    className={classNames(
                        "flex flex-center background-200 flex-shrink-0",
                        getType(container?.owner) === 'organization' && 'rounded-xl'
                    )}
                />,
                isOrgAnnouncement,
                <Avatar
                    size={40}
                    src={_.get(organization, 'avatar')}
                    icon={<BiSolidChurch size={20} className="text-primary-500"/>}
                    className="flex flex-center bg-primary-50 rounded-xl flex-shrink-0"
                />,
            )}
            {ifThenElseMultipleConditions(
                <div className="flex flex-col flex-1 min-w-0">
                    <Link
                        to={getLinkToDetail(item?.owner)}
                        className="font-bold text-sm text-gray-800 tracking-wide truncate no-underline">
                        {getTitle(item?.owner)}
                    </Link>
                    <div className="flex items-center min-w-0 leading-snug">
                        <span className="mr-1 flex-shrink-0 text-xs text-color-300 tracking-wider">
                            {/*{t('posted').toLowerCase()}*/}
                            <label>
                                {formatRelativeTime(created)}
                            </label>
                            {/*{t('on channel')}*/}
                        </span>
                        {item.container && (
                            <>
                                <span className="ml-1 mr-1 flex-shrink-0 text-color-300">
                                    {`\u2022 `}
                                </span>
                                <Link
                                    to={getLinkToDetail(item.container)}
                                    className="min-w-0 block truncate font-semibold text-xs text-color-200 hover:text-color-100 no-underline">
                                    {getTitle(item.container)}
                                </Link>
                            </>
                        )}

                        <div className="flex-shrink-0 ml-1 leading-4">
                            <FollowButton
                                renderLabel={(_item) => renderIf(
                                    !_item?.follow_status,
                                    <label
                                        className="text-xs not-italic cursor-pointer">{`\u2022 ${t('follow')}`}</label>
                                )}
                                item={item?.container}
                            />
                        </div>
                    </div>
                </div>,
                getId(item?.owner) === getId(item.container),
                isOrgAnnouncement ? (
                    <div className="flex-1 space-x-1 organization_announcement_title">
                        <div className="items-baseline space-x-1 leading-tight">
                            <Link
                                to={getLinkToDetail(organization)}
                                className="font-semibold text-primary-900 no-underline">
                                {getTitle(organization)}
                            </Link>
                            <span className="text-color-400 italic tracking-wider">
                            <label style={{fontStyle: 'normal'}} className="mx-1 font-normal text-color-100">
                                {formatRelativeTime(item?.created)}
                            </label>
                                {t('notified')}
                        </span>
                        </div>
                    </div>
                ) : isCourseClassAnnouncement ? (
                    <div className="flex-1 space-x-1 course_class_announcement_title">
                        <div className="items-baseline space-x-1 leading-tight">
                            <Link
                                to={getLinkToDetail(course_class?.course)}
                                className="font-semibold text-primary-900 no-underline">
                                {course_class?.course?.title}
                            </Link>
                            <span className="text-color-400 italic tracking-wider">
                                <label style={{fontStyle: 'normal'}} className="mx-1 font-normal text-color-100">
                                    {formatRelativeTime(item?.created)}
                                </label>
                                {t('notified')}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col flex-1">
                        <div className="items-baseline space-x-1 leading-tight">
                            <Link
                                to={getLinkToDetail(item?.owner)}
                                className="font-bold text-sm text-gray-800 no-underline">
                                {getTitle(item?.owner)}
                            </Link>
                            <FollowButton
                                renderLabel={(_item) => renderIf(
                                    !_item?.follow_status,
                                    <label
                                        className="text-xs not-italic cursor-pointer">{`\u2022 ${t('follow')}`}</label>
                                )}
                                item={item?.container}
                            />
                        </div>
                        <span className="text-xs text-color-300 tracking-wider whitespace-no-wrap">
                            {formatRelativeTime(created)}
                        </span>
                    </div>
                ),
                item?.action === 're-post',
                <div className="flex flex-col flex-1 min-w-0">
                    <Link
                        to={getLinkToDetail(item?.owner)}
                        className="font-bold text-sm text-gray-800 tracking-wide truncate no-underline">
                        {getTitle(item?.owner)}
                    </Link>
                    <div className="flex items-center min-w-0 leading-snug">
                        <span className="mr-1 flex-shrink-0 text-xs text-color-300 tracking-wider">
                            <label>
                                {formatRelativeTime(created)}
                            </label>
                            {/*{t('on channel')}*/}
                        </span>
                        {item.container && (
                            <>
                                <span className="ml-1 mr-1 flex-shrink-0 text-color-300">
                                    {`\u2022 `}
                                </span>
                                <Link
                                    to={getLinkToDetail(item.container)}
                                    className="min-w-0 block truncate font-semibold text-xs text-color-200 hover:text-color-100 no-underline">
                                    {getTitle(item.container)}
                                </Link>
                            </>
                        )}
                        <div className="flex-shrink-0 ml-1 leading-4">
                            <FollowButton
                                renderLabel={(_item) => renderIf(
                                    !_item?.follow_status,
                                    <label
                                        className="text-xs not-italic cursor-pointer">{` \u2022 ${t('follow')}`}</label>
                                )}
                                item={item?.container}
                            />
                        </div>
                    </div>
                </div>,
            )}
            <MetaActions/>
        </div>
    )
}
